import React, { isValidElement } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@ohif/ui-next';
import './AppTooltip.css';

type TooltipSide = 'top' | 'right' | 'bottom' | 'left';
type TooltipAlign = 'start' | 'center' | 'end';

interface AppTooltipProps {
  content?: React.ReactNode;
  children: React.ReactNode;
  side?: TooltipSide;
  align?: TooltipAlign;
  sideOffset?: number;
  maxWidth?: number;
  className?: string;
  contentClassName?: string;
  disabled?: boolean;
}

const AppTooltip: React.FC<AppTooltipProps> = ({
  content,
  children,
  side = 'top',
  align = 'center',
  sideOffset = 8,
  maxWidth = 280,
  className = '',
  contentClassName = '',
  disabled = false,
}) => {
  if (disabled || content === undefined || content === null || content === '') {
    return <>{children}</>;
  }

  const triggerChild = isValidElement(children)
    ? children
    : <span className="app-tooltip__trigger-text">{children}</span>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {triggerChild}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={`app-tooltip ${className}`.trim()}
        style={{ maxWidth }}
      >
        <div className={`app-tooltip__content ${contentClassName}`.trim()}>
          {content}
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default AppTooltip;
